import { ZERO } from '@/constants';
import { Avatar, Typography } from '@/ui';

import type { Company } from '@/types';
import type { FC } from 'react';

interface CollapsedCompanySummaryProps {
  company: Company;
}

/**
 * Compact company identity shown in the collapsed dashboard header, where the
 * side panel is reduced to a toggle-only rail and no longer carries the name.
 */
export const CollapsedCompanySummary: FC<CollapsedCompanySummaryProps> = ({
  company,
}) => (
  <div className="flex min-w-0 items-start gap-5">
    <Avatar icon="domain" size="s" src={company.avatarUrl} />
    <div className="min-w-0">
      <Typography className="break-words" variant="h4">
        {company.name}
      </Typography>
      <div className="mt-1 flex flex-col gap-1">
        <Typography variant="body1">
          {company.usersCount || ZERO} members
        </Typography>
        {!!company.location && (
          <Typography variant="body1">{company.location}</Typography>
        )}
      </div>
    </div>
  </div>
);

export default CollapsedCompanySummary;
